import React, {useState} from 'react'
import axios from 'axios';
import API from '../../API';

const OptionDel = ({project_id}) => {
    const [showModal, setShowModal] = useState(false);
    const data = {
        id: project_id,
        is_soft_delete:false
    }
    const deleteProject = () => {
        axios.put(API.baseURL+`/projects/${project_id}/soft_delete`,
        data,
        API.options
        ) .then((res) => {
            window.location.href = "/dashboard/projects/0"
        })
    }

    return (
        <div className="ec-option ec-option--delete">
            <div onClick={() => setShowModal(true)}>
                <div className="d-flex align-items-center">
                    {/* <span className="ec-option__icon">
                        <span className="icon ec-icon--blue icon-delete-fill"></span>
                    </span> */}
                    <span className="ec-option__label">
                        Delete
                    </span>
                </div>
            </div>
            {/* <Option optionIcon="delete-fill" optionLabel="Delete" onClick={() => setShowModal(true)} /> */}
            {showModal && (
                <div className="ec-modal ec-modal--xs">
                    <div className="ec-modal__inwrap">
                        <div className="ec-modal__header ec-modal__header ec-modal__header--bidder">
                            <span className="ec-modal__title ec-modal__title--bidder">Are you sure to delete this?</span>
                            <span className="ec-modal__close ec-modal__close--bidder">
                                <button onClick={() => setShowModal(false)}>
                                    <img alt="" src="/assets/images/projects/icons/close.svg" />
                                </button>
                            </span>
                        </div>
                        <div className="ec-modal__body">
                            <div className="ec-modal__actions">
                                <div className="ec-modal__action-item">
                                    <div className="ec-modal__action ec-btn ec-btn--cancle" onClick={()=>deleteProject()}>
                                        <span>Delete</span>
                                    </div>
                                </div>
                                <div className="ec-modal__action-item">
                                    <div className="ec-modal__action ec-btn ec-btn--accept" onClick={() => setShowModal(false)}>
                                        <span>Cancel</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default OptionDel;


